import { Component, Input, forwardRef, Output, EventEmitter, ViewEncapsulation, ElementRef, ViewChild, ViewChildren } from '@angular/core';
import { Validator, ControlValueAccessor, NG_VALUE_ACCESSOR, AbstractControl, NG_VALIDATORS } from '@angular/forms';
import { ContentChange, EditorChangeContent, EditorChangeSelection, QuillEditorComponent } from 'ngx-quill';
import Quill from 'quill';
import { SabisTranslateService } from 'sabis-components2';


@Component({
  selector: 'sabis-texteditor2',
  templateUrl: './text-editor.component.html',
  styleUrls: ['./text-editor.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SabisTextEditor2Component),
    multi: true
  },
  {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => SabisTextEditor2Component),
    multi: true,
  }]
})
export class SabisTextEditor2Component implements Validator, ControlValueAccessor {
  @Input('scLabel') scLabel: string = '';
  @Input('scPlaceholder') scPlaceholder: string = '';
  @Input('scHideValidationMessage') scHideValidationMessage: boolean = false;
  @Input('scMaxLength') scMaxLength: number = 0;
  @Input('scShowAlignment') scShowAlignment: boolean = true;
  @Input('scShowFontColor') scShowFontColor: boolean = true;
  @Input('scShowTextHighlight') scShowTextHighlight: boolean = true;
  @Input('scShowToolbar') scShowToolbar: boolean = true;
  @Input('scUseTextFormat') scUseTextFormat: boolean = false;
  @Input('scShowTextCount') scShowTextCount: boolean = true;

  @Output() scOnSelectionChanged = new EventEmitter<any>();

  @ViewChild(QuillEditorComponent, { static: false }) editorComponent!: QuillEditorComponent;

  public quill!: Quill;

  public editorValue: string = '';
  public isDisabled: boolean = false;

  public validationMessage: string = '';
  isValid: boolean = true;
  editorFormat: "object" | "html" | "text" | "json" = 'html';
  remainingCount: number = 0;

  customOptions = [{
    import: 'attributors/style/size',
    whitelist: ['8pt', '9pt', '10pt', '11pt', '12pt', '14pt', '16pt', '18pt', '20pt', '22pt', '24pt', '26pt', '28pt', '30pt', '32pt', '36pt', '48pt', '72pt']
  },
  {
    import: 'attributors/style/font',
    whitelist: ['sans-serif', 'monosapce', 'serif', 'Georgia', 'palatino-linotype', 'times-new-roman', 'Arial', 'Helvetica', 'arial-black',
      'comic-sans-ms', 'Charcoal', 'Impact', 'lucida-sans-unicode', 'lucida-grande', 'Tahoma', 'Geneva', 'trebuchet-ms', 'Verdana',
      'courier-new', 'lucida-console', 'Mirza', 'Roboto', 'Aref', 'Calibri']
  }
  ];


  constructor(private el: ElementRef, private _translateService: SabisTranslateService) {

    //const Parchment = Quill.import('parchment');
    //let Block = Parchment.query('block');

    //Block.tagName = 'DIV';
    //Quill.register(Block, true);
  }

  ngAfterViewInit(): void {

    ////Tab
    //this.quill.quillEditor.keyboard.bindings[9].unshift({
    //  key: 9,
    //  handler: this.handleKeys.bind(this)
    //});
    ////Enter
    //this.quill.quillEditor.keyboard.bindings[13].unshift({
    //  key: 13, handler: this.handleKeys.bind(this)
    //});

    ////backsapce
    //this.quill.quillEditor.keyboard.bindings[8].unshift({
    //  key: 8, handler: this.handleKeys.bind(this)
    //});

    ////Delete
    //this.quill.quillEditor.keyboard.bindings[46].unshift({
    //  key: 46, handler: this.handleKeys.bind(this)
    //});


    //this.quill.quillEditor.emitter.listeners['click'].unshift({
    //  node: document.body,
    //  handler: this.handleKeys.bind(this)
    //});

    //this.quill.quillEditor.emitter.listeners['mouseup'].unshift({
    //  node: document.body,
    //  handler: this.handleKeys.bind(this)
    //});

    //this.quill.quillEditor.emitter.listeners['mousedown'].unshift({
    //  node: document.body,
    //  handler: this.handleKeys.bind(this)
    //});



    //set the editor format type
    if (this.scUseTextFormat) {
      this.editorFormat = 'text';
    }
  }

  onSelectionChanged(event: any) {
    this.scOnSelectionChanged.emit(event);
  }

  getSelection(focus = false): { index: Number, length: Number } | null {
    if (focus === true) {
      return this.quill.getSelection(focus);
    }
    else {
      return this.quill.getSelection();
    }
  }
  insertText(index: number, text: string): any {
    //this.quill.quillEditor.insertText(0, " " , '' , 'user');
    this.quill.insertText(index, text);
  }
  setSelection(range: { index: number, length: number }, source = 'api') {
    this.quill.setSelection(range.index, range.length, 'api');
  }

  writeValue(obj: any) {
    this.editorValue = obj;
  }
  registerOnTouched(fn: any): void {
    this.editorComponent?.registerOnTouched(fn);
  }

  private _valueChangedCallback: (modelValue: any) => void = () => { };
  registerOnChange(fn: any): void {
    this._valueChangedCallback = fn;
  }

  public onValueChanged(value: any): void {
    this._valueChangedCallback(value);
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  validate(c: AbstractControl): { [key: string]: any; } | null {
    this.setValidationMessage(c);
    var validation = this.editorComponent?.validate();
    if (validation != null) {
      return validation;
    }
    return null;
  }

  private setValidationMessage(c: AbstractControl): void {
    //set Time out because the control changes validation after passing in the validate function
    setTimeout(() => {
      if (c.errors && c.errors['maxlength']) {
        delete c.errors['maxlength']
      }
      this.isValid = c.errors == null;
      if (c.errors && Object.keys(c.errors).length == 0) {
        this.isValid = true;
      }
      if (!this.isValid) {
        for (var e in c.errors) {
          if (e == "required" && c.touched) {
            this.validationMessage = this._translateService.instant("SabisComponents.FieldRequired");
          }
          else if (e == "maxLengthError") {
            this.validationMessage = this._translateService.instant("SabisComponents.MaxLengthIs") + " " + c.errors['maxLengthError'].maxLength;
          }
          else {
            this.validationMessage = "";
          }
          break;
        }
      }
    });
  }

  onEditorCreated(quill: Quill) {
    this.quill = quill;
    //set editor toolbar visibility
    //this.quill.getModule('toolbar').container.hidden = !this.scShowToolbar;
  }

  onEditorChanged(quill: EditorChangeContent | EditorChangeSelection) {
  }

  onContentChanged(event: ContentChange) {
    if (this.scMaxLength) {
      const count = this.scMaxLength + 1 - event.text.length
      this.remainingCount = count >= 0 ? count : 0;
    }
  }
}
